export { default as AuthMutation } from "./mutation.graphql";
export { default as AuthQuery } from "./query.graphql";
